export default {
  methods: {
    idb_get(dbName, storeName) {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName);

        request.onsuccess = function (event) {
          const db = event.target.result;

          if (!db.objectStoreNames.contains(storeName)) {
            return resolve(null);
          }

          const tx = db.transaction(storeName, "readonly");
          const store = tx.objectStore(storeName);

          const getReq = store.getAll();

          getReq.onsuccess = function () {
            resolve(getReq.result);
          };

          getReq.onerror = reject;
        };

        request.onerror = reject;
      });
    },

    async firebase_indexedDB() {
      try {
        const firebaseDB = await this.idb_get(
          "firebaseLocalStorageDb",
          "firebaseLocalStorage"
        );

        if (firebaseDB) {
          return firebaseDB.find((e) => e.fbase_key.match(/firebase:authUser/));
        }

        return null;
      } catch (err) {
        console.error(err);
        throw err;
      }
    },
  },
};
